export const LOGIN_SUCCESS 	= "LOGIN_SUCCESS";
export const LOGIN 			= "LOGIN";
export const LOGOUT 		= "LOGOUT";
export const SIGN_UP 		= "SIGN_UP";
export const CLEAR_USER_DATA 		= "CLEAN_USER_DATA";
export const UPDATE_USER = "UPDATE_USER";

export const LOAD_HOMEPAGE_STATS = "LOAD_HOMEPAGE_STATS";

export const TOKEN 			= "TOKEN";
export const UPDATE_TOKEN = "UPDATE_TOKEN";


export const HOME_SCREEN_STAT 		= "HOME_SCREEN_STAT";
export const CLEAR_HOME_SCREEN_STAT 		= "CLEAR_SCREEN_STAT";
export const CLEAR_ALL_REDUCERS_DATA 		= "CLEAR_ALL_REDUCERS_DATA";

export const RELOAD_SYSTEM_DATA 		= "RELOAD_ACCOUNT_DATA";
export const RELOAD_SYSTEM_DATA_POST 		= "RELOAD_SYSTEM_DATA_POST";


export const RESEND_VERIFY_EMAIL 		= "RESEND_VERIFY_EMAIL";
export const VERIFY_EMAIL 		= "VERIFY_EMAIL";


export const SAVE_REMOTE_SITE_SETTINGS 		= "SAVE_REMOTE_SITE_SETTINGS";
export const SAVE_LOCAL_SITE_SETTINGS 		= "SAVE_LOCAL_SITE_SETTINGS";
export const ACTION_LOCAL_SITE_SETTINGS 		= "ACTION_LOCAL_SITE_SETTINGS";


export const SAVE_TICKER_HOME 			= "SAVE_TICKER_HOME";

export const FETCH_FX_HEAD 		= "FETCH_FX_HEAD";
export const SAVE_FX_HEAD 		= "SAVE_FX_HEAD";



export const TRADE_DUMMY 		= "TRADE_DUMMY";
export const TRADE_DUMMY_POST 		= "TRADE_DUMMY_POST";
export const TRADE_POST 		= "TRADE_POST";
export const TRADE_GET 			= "TRADE_GET";
export const TRADE_SAVE 		= "TRADE_SAVE";


export const EXCHANGE_POST 		= "EXCHANGE_POST";
export const EXCHANGE_GET 			= "EXCHANGE_GET";
export const EXCHANGE_SAVE 		= "EXCHANGE_SAVE";


export const SAVE_DEPOSIT_DATA 		= "SAVE_DEPOSIT_DATA";
export const MANAGE_DEPOSIT 		= "MANAGE_DEPOSIT";
export const ALL_DEPOSIT 			= "ALL_DEPOSIT";


export const SAVE_WITHDRAWAL_DATA 		= "SAVE_WITHDRAWAL_DATA";
export const MANAGE_WITHDRAWAL 			= "MANAGE_WITHDRAWAL";
export const ALL_WITHDRAWALS 			= "ALL_WITHDRAWALS";

export const MANAGE_NOTIFICATION 			= "MANAGE_NOTIFICATION";
export const CHANGE_NOTIFICATION_NOW 			= "CHANGE_NOTIFICATION_NOW";







export const SUBMIT_BET_REQUEST 			= "SUBMIT_BET_REQUEST";
export const SAVE_USER_BETS_DISK 				= "SAVE_USER_BETS_DISK";

export const GET_ALL_FIXTURE 				= "GET_ALL_FIXTURE";
export const SAVE_ALL_FIXTURE_DISK 			= "SAVE_ALL_FIXTURE_DISK";

export const SAVE_HOME_RECENT_DISK 			= "SAVE_HOME_RECENT_DISK";
export const LOAD_RECENT_BETS 				= "LOAD_RECENT_BETS";

export const LOAD_USER_BETS 				= "LOAD_USER_BETS";

export const SAVE_BET_SLIP_INFO_DISK 			= "SAVE_BET_SLIP_INFO_DISK";
export const TOGGLE_BET_SLIP_MODAL 				= "TOGGLE_BET_SLIP_MODAL";

export const ADD_FIXTURE_TO_BET_SLIP_ON_DISK 				= "ADD_FIXTURE_TO_BET_SLIP_ON_DISK";
export const REMOVE_FIXTURE_FROM_BET_SLIP_ON_DISK 				= "REMOVE_FIXTURE_FROM_BET_SLIP_ON_DISK";
export const CLEAR_ALL_FIXTURE_FROM_BET_SLIP_ON_DISK 				= "CLEAR_ALL_FIXTURE_FROM_BET_SLIP_ON_DISK";
export const ADD_FIXTURE_TO_BET_SLIP_ON_ACTION 				= "ADD_FIXTURE_TO_BET_SLIP_ON_ACTION";
export const REMOVE_FIXTURE_FROM_BET_SLIP_ON_ACTION 				= "REMOVE_FIXTURE_FROM_BET_SLIP_ON_ACTION";
export const CLEAR_ALL_FIXTURE_FROM_BET_SLIP_ON_ACTION 				= "CLEAR_ALL_FIXTURE_FROM_BET_SLIP_ON_ACTION";

export const MANAGE_AMOUNT_TO_BET_SLIP_ACTION 				= "MANAGE_AMOUNT_TO_BET_SLIP_ACTION";
export const MANAGE_AMOUNT_TO_BET_SLIP_DISK 				= "MANAGE_AMOUNT_TO_BET_SLIP_DISK";

export const SAVE_ALL_MATCH_RESULTS_DISK 				= "SAVE_ALL_MATCH_RESULTS_DISK";
export const ALL_MATCH_RESULTS_ACTION 				= "ALL_MATCH_RESULTS_ACTION";

export const SAVE_ALL_LIVE_MATCH_TO_DISK 				= "SAVE_ALL_LIVE_MATCH_TO_DISK";
export const SAVE_ALL_LIVE_MATCH_TO_ACTION 				= "SAVE_ALL_LIVE_MATCH_TO_ACTION";
export const SAVE_ALL_CANCELLED_MATCH_TO_DISK 				= "SAVE_ALL_CANCELLED_MATCH_TO_DISK";
export const SAVE_ALL_CANCELLED_MATCH_TO_ACTION 				= "SAVE_ALL_CANCELLED_MATCH_TO_ACTION";






export const LOAN_POST 						= "LOAN_POST";
export const LOAN_GET 						= "LOAN_GET";
export const LOAN_DUMMY 					= "LOAN_DUMMY";
export const LOAN_DUMMY_POST 				= "LOAN_DUMMY_POST";
export const LOAN_SAVE 						= "LOAN_SAVE";

